import { encounterApi } from '../encounterApi';
import {
  ScheduleExportRequest,
  ScheduleItemType,
  ScheduleRequest,
} from '../types/scheduleTypes';

const scheduleEndpoints = encounterApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get schedule items for a center and date range
    // GET /schedule?centerId=<centerId>&startDate=<startDate>&endDate=<endDate>
    getScheduleItems: builder.query<ScheduleItemType[], ScheduleRequest>({
      query: (request) => ({
        url: '/schedule',
        params: {
          centerId: request.centerId,
          startDate: request.startDate,
          endDate: request.endDate,
        },
      }),
      providesTags: ['Encounters'],
    }),

    // Get schedule export for a company/center and date range
    // GET /schedule-export?company=<company>&center=<center>&startDate=<startDate>&endDate=<endDate>
    getScheduleExport: builder.query<ScheduleItemType[], ScheduleExportRequest>({
      query: (request) => ({
        url: '/schedule-export',
        params: {
          company: request.company,
          center: request.center,
          startDate: request.startDate,
          endDate: request.endDate,
        },
      }),
      providesTags: ['Encounters'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetScheduleItemsQuery,
  useGetScheduleExportQuery,
} = scheduleEndpoints;
